module.exports = __webpack_public_path__ + "7620a3b9070541a143564c395e8abe8d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/icons/more.svg
// module id = 892
// module chunks = 34